import { createSlice } from '@reduxjs/toolkit';

const options = {
  name: 'qrCodeFilters',
  initialState: {
    suspect: false,
    used: false,
    clean: false,
  },
  reducers: {
    setSuspect: (state, action) => ({
      ...state,
      suspect: action.payload,
    }),
    setUsed: (state, action) => ({
      ...state,
      used: action.payload,
    }),
    setClean: (state, action) => ({
      ...state,
      clean: action.payload,
    }),
    cleanSuspect: (state) => ({
      ...state,
      suspect: false,
    }),
    cleanUsed: (state) => ({
      ...state,
      used: false,
    }),
    cleanClean: (state) => ({
      ...state,
      clean: false,
    }),
  },
};

const qrCodeFiltersSlice = createSlice(options);

export const getFilters = (state) => state.qrCodeFilters;
export const getSuspect = (state) => state.qrCodeFilters.suspect;
export const getUsed = (state) => state.qrCodeFilters.used;
export const getClean = (state) => state.qrCodeFilters.clean;
export const { setSuspect, setUsed, setClean, cleanSuspect, cleanUsed, cleanClean } = qrCodeFiltersSlice.actions;

export default qrCodeFiltersSlice;
